import { CssBaseline, ThemeProvider } from '@mui/material';
import { Router } from '@reach/router';
import { createRoot } from 'react-dom/client';

import { AuthProvider } from './contexts/AuthContext';
import { RealtimeProvider } from './providers/RealtimeProvider';
import theme from './theme';

import AuthPage from './pages/auth';
import CalendarPage from './pages/calendar';
import CategoriesPage from './pages/categories';
import ClientsPage from './pages/clients.jsx';
import CloudPage from './pages/cloud';
import CMSPage from './pages/cms';
import DashboardPage from './pages/dashboard';
import DealsPage from './pages/deals.jsx';
import ExpensesPage from './pages/expenses';
import IndexPage from './pages/index';
import IntegrationsPage from './pages/integrations';
import LeadsPage from './pages/leads.jsx';
import LeadsFormDemoPage from './pages/leads-form-demo';
import OrganizationsPage from './pages/organizations';
import PipelinePage from './pages/pipeline';
import PipelineSimplePage from './pages/pipeline-simple';
import ProductsPage from './pages/products';
import SectionsPage from './pages/sections';
import TasksPage from './pages/tasks';
import WhatsappPage from './pages/whatsapp';

function AppRouter() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <RealtimeProvider>
          <Router>
            <IndexPage path="/" />
            <DashboardPage path="/dashboard" />
            <LeadsPage path="/leads" />
            <DealsPage path="/deals" />
            <ProductsPage path="/products" />
            <ClientsPage path="/clients" />
            <TasksPage path="/tasks" />
            <CategoriesPage path="/categories" />
            <ExpensesPage path="/expenses" />
            <SectionsPage path="/sections" />
            <PipelinePage path="/pipeline" />
            <PipelineSimplePage path="/pipeline-simple" />
            <OrganizationsPage path="/organizations" />
            <IntegrationsPage path="/integrations" />
            <CloudPage path="/cloud" />
            <CMSPage path="/cms" />
            <CalendarPage path="/calendar" />
            <WhatsappPage path="/whatsapp" />
            <LeadsFormDemoPage path="/leads-form-demo" />
            <AuthPage path="/auth" />
          </Router>
        </RealtimeProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(<AppRouter />);


